module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CaSbLh/tc-custom/9781780106519.jpg?1726871242406",
      "alt": "This image is the cover for the book Daughter of Ashes, The Hannah Ives Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Daughter of Ashes, The Hannah Ives Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Amateur sleuth Hannah Ives has a new home, but after a gruesome discovery in the chimney, she has a new case on her hands. ")]), _vm._v(" "), _c('b', [_vm._v("Is a tragic discovery from the past triggering a number of shocking present-day events?")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" When Hannah loses out on the cottage of her dreams because of an unscrupulous real estate agent, she and her husband, Paul, buy a fixer-upper instead. But contractors restoring the chimney soon make a tragic discovery: the mummified body of an infant."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Hannah, already researching the history of her home in the county archives, is searching for clues to the dead infant’s identity when more shocking events occur. Suddenly, her access to the courthouse is denied and the records she has been examining are slated for destruction. Someone with money, influence, or both is trying to make sure incriminating information stays buried. Can Hannah solve the crimes before the evidence and over one hundred years of county history go up in smoke?"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Readers who haven’t met Hannah should do so promptly.” ―"), _c('i', [_vm._v("Booklist")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marcia Talley\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Severn House\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0